/**
 * 代步补贴
 */
import { TRAVELRECORD } from '../types';

export default {
    name: `${TRAVELRECORD}`,
    path: '/travelRecord',
    component: () => import(/* webpackChunkName: 'travelRecord' */ '@/views/travelRecord/'),
    redirect: { name: `${TRAVELRECORD}Index` },
    meta: {
        title: '代步补贴',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${TRAVELRECORD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'travelRecord' */ '@/views/travelRecord/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${TRAVELRECORD}Detail`,
            path: 'detail',
            component: () => import(/* webpackChunkName: 'travelRecord' */ '@/views/travelRecord/detail/Detail.vue'),
        },
    ],
};
